import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const CRMConfigPanel = () => {
  const [config, setConfig] = useState({
    leadScoringThreshold: 75,
    commissionLevel1: 5,
    commissionLevel2: 3,
    commissionLevel3: 2,
    commissionLevel4: 1
  });

  const handleSave = () => {
    // TODO: Save configuration to Supabase
    console.log('Saving CRM config:', config);
  };

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground flex items-center">
          <Icon name="Settings" size={24} className="mr-2 text-primary" />
          Configuración del CRM
        </h2>
      </div>

      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium text-foreground mb-2 block">
            Umbral de Lead Scoring
          </label>
          <Input
            type="number"
            value={config?.leadScoringThreshold}
            onChange={(e) => setConfig({ ...config, leadScoringThreshold: e?.target?.value })}
            placeholder="75"
          />
        </div>

        <div className="border-t border-border pt-4">
          <h3 className="text-sm font-semibold text-foreground mb-3">Comisiones por Nivel</h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <span className="text-sm text-muted-foreground w-24">Nivel 1:</span>
              <Input
                type="number"
                value={config?.commissionLevel1}
                onChange={(e) => setConfig({ ...config, commissionLevel1: e?.target?.value })}
                placeholder="5"
              />
              <span className="text-sm text-muted-foreground">%</span>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-sm text-muted-foreground w-24">Nivel 2:</span>
              <Input
                type="number"
                value={config?.commissionLevel2}
                onChange={(e) => setConfig({ ...config, commissionLevel2: e?.target?.value })}
                placeholder="3"
              />
              <span className="text-sm text-muted-foreground">%</span>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-sm text-muted-foreground w-24">Nivel 3:</span>
              <Input
                type="number"
                value={config?.commissionLevel3}
                onChange={(e) => setConfig({ ...config, commissionLevel3: e?.target?.value })}
                placeholder="2"
              />
              <span className="text-sm text-muted-foreground">%</span>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-sm text-muted-foreground w-24">Nivel 4:</span>
              <Input
                type="number"
                value={config?.commissionLevel4}
                onChange={(e) => setConfig({ ...config, commissionLevel4: e?.target?.value })}
                placeholder="1"
              />
              <span className="text-sm text-muted-foreground">%</span>
            </div>
          </div>
        </div>

        <Button
          fullWidth
          iconName="Save"
          onClick={handleSave}
        >
          Guardar Configuración
        </Button>
      </div>
    </div>
  );
};

export default CRMConfigPanel;